import React, { useContext, useState, useEffect } from "react";
import { Button, Modal, Row, Col, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { getAccountWaveBalance, getAccountAssetBalance } from '../blockchain functions/BlockchainFunctions.js';
import { LoginContext } from "../../context/LoginContext";

import copySymbol from "../assets/icons/copy-symbol.svg"
import account from '../assets/icons/user-profile.svg';
import logo from '../assets/logo.png';
import waveSymbol from '../assets/icons/wave-symbol.png';

function AccountDetailsModel(props) {

  const [loginData, setLoginData] = useContext(LoginContext);

  const setLogOut = () => {
    setLoginData({
      email: "",
      password: "",
      walletAddress: "",
      phrase: "",
      publicKey: "",
      privateKey: ""
    });
    sessionStorage.removeItem("userData");
    props.onHide();
  }

  const GetBalance = () => {
    const [walletBalanceWave, setWalletBalanceWave] = useState(0);
    const [walletBalanceAsset, setWalletBalanceAsset] = useState(0);

    useEffect(async () => {
      setWalletBalanceWave(await getAccountWaveBalance(loginData.walletAddress));
      setWalletBalanceAsset(await getAccountAssetBalance(loginData.walletAddress));
    }, []);

    return (
      <span>
        <img style={{ height: "2rem" }} src={logo} /> {walletBalanceAsset} PANDAS<br />
        <img style={{ height: "2rem" }} src={waveSymbol} /> {walletBalanceWave} Waves
      </span>
    );
  }


  // return a promise
  function copyToClipboard(textToCopy) {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
      // navigator clipboard api method'
      return navigator.clipboard.writeText(textToCopy);
    } else {
      // text area method
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
        // here the magic happens
        document.execCommand('copy') ? res() : rej();
        textArea.remove();
      });
    }
  }

  function copyTextToClipboard(copyText) {
    
    copyToClipboard(copyText).then(() => toast.info("wallet address copied"))
    .catch(() => console.log('error'));
    /* Copy the text inside the text field */
    // navigator.clipboard.writeText(copyText);

    /* Alert the copied text */
    // toast.info("wallet address copied");
  }

  return (
    <Modal {...props} dialogClassName="modal-90w" aria-labelledby="contained-modal-title-vcenter" centered >

      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          <img style={{ height: "2rem" }} src={account} /> Account Details
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p className="data-key">Email : <span className="data-value">{loginData?.email}</span></p>
        <p className="data-key">WalletAddress : <span className="data-value">{loginData?.walletAddress}</span>
          &ensp;<img width="25px" src={copySymbol} onClick={() => copyTextToClipboard(loginData?.walletAddress)} /></p>
        <p className="data-key">WalletBalance : <br /><span className="data-value"><GetBalance /></span></p>
        <Button className="float-right" variant="secondary" onClick={setLogOut}>Logout</Button>
      </Modal.Body>

    </Modal>
  );
}

export default AccountDetailsModel